// test2169
(2169 && 0);
